import { COOKIE_NAMES } from '~/common/constants/localStorage';
import { CONSENT_TTL_MS } from '~/common/constants/consent';

export const GTM_ID = 'GTM-W5B35RKP' as const;

function loadGTMScriptSnippet(): string {
  return `
    (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
    'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
    })(window,document,'script','dataLayer','${GTM_ID}');
  `;
}

export const GoogleTagManagerHead = () => {
  if (!GTM_ID) return null;

  return (
    <script
      dangerouslySetInnerHTML={{
        __html: `
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          
          gtag('consent', 'default', {
            'analytics_storage': 'denied',
            'ad_storage': 'denied',
            'ad_user_data': 'denied',
            'ad_personalization': 'denied',
            'functionality_storage': 'granted',
            'security_storage': 'granted',
            'wait_for_update': 500,
          });

          var gtmLoaded = false;
          function loadGTM() {
            if (gtmLoaded) return;
            gtmLoaded = true;
            ${loadGTMScriptSnippet()}
          }
          window.__loadGTM = loadGTM;

          try {
            var cookies = document.cookie.split('; ');
            var consentCookie = cookies.find(function(c) { return c.startsWith('${COOKIE_NAMES.cookieConsent}='); });
            if (consentCookie) {
              var raw = decodeURIComponent(consentCookie.split('=').slice(1).join('='));
              var state = JSON.parse(raw);
              var tsMs = state && state.ts ? new Date(state.ts).getTime() : 0;
              var notExpired = !isNaN(tsMs) && (tsMs + ${CONSENT_TTL_MS}) > Date.now();
              var hasAnalytics = state && state.analytics === true && notExpired;
              var hasMarketing = state && state.marketing === true && notExpired;
              var hasFunctionality = state && state.functionality === true && notExpired;
              if (hasAnalytics || hasMarketing) {
                gtag('consent', 'update', {
                  'analytics_storage': hasAnalytics ? 'granted' : 'denied',
                  'ad_storage': hasMarketing ? 'granted' : 'denied',
                  'ad_user_data': hasMarketing ? 'granted' : 'denied',
                  'ad_personalization': hasMarketing ? 'granted' : 'denied',
                  'functionality_storage': hasFunctionality ? 'granted' : 'denied',
                });
              }
            }
          } catch(e) {}

          /*
            Consent Mode advanced: GTM loads on every page view, never gated on the banner.
            Consent defaults to denied above and any stored grant is applied before this call, so
            visitors who have not answered the banner produce cookieless pings rather than nothing
            at all — which is what lets Google model conversions. Do not move this back inside the
            consent branch; see specs/gtm-consent-mode.md.
          */
          loadGTM();
        `,
      }}
    />
  );
};

declare global {
  interface Window {
    dataLayer: any[];
    gtag?: (...args: any[]) => void;
    __loadGTM?: () => void;
  }
}
